var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('div',{},[_c('petty-cash-certificate-form-box',{attrs:{"form-type":_vm.formType,"isSubmission":_vm.isSubmission},on:{"add":_vm.onAdd,"edit":_vm.onEdit,"approve":_vm.handleApprove,"reject":_vm.handleReject}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }